import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';

//Servicios
import { TokenReaderService } from '@/app/services/security/token-reader.service';
import { LogoutService } from '@/app/services/security/logout.service';
import { UsuarioService } from '@/app/services/usuario.service';

//Libreríae exernas
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthService } from '@auth0/auth0-angular';
import { filter, finalize, take } from 'rxjs';


@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LoginComponent implements OnInit {
  private auth0Service = inject(AuthService);
  private logoutService = inject(LogoutService);
  private tokenReaderService = inject(TokenReaderService);
  private router = inject(Router);
  private usuarioService = inject(UsuarioService);
  private toastr = inject(ToastrService);
  private spinner = inject(NgxSpinnerService);

  //Variable global para intercambiar formularios
  displayForm: string | null = null;

  //Ng-Model
  UserLoginRQ = {
    userName: '',
    password: '',
  };

  ResetPasswordRQ = {
    employeeNumber: ''
  }

  constructor() {}

  ngOnInit() {
    this.auth0Service.idTokenClaims$.pipe(
      filter((claims: any) => !!claims),
      take(1)
    ).subscribe(() => {
      this.loginWithOkta();
    });
  }

  login(){
    // prompt:'login' obliga a re-autenticarse en cada inicio de sesión. Auth0
    // propaga este parámetro al IdP federado (Okta/GateOne), de modo que aunque
    // su sesión SSO siga viva, vuelve a pedir credenciales. No cierra la sesión
    // del IdP (eso requiere el logout federado), pero elimina el reingreso
    // silencioso por SSO y queda enteramente bajo nuestro control.
    this.auth0Service.loginWithRedirect({
      authorizationParams: { prompt: 'login' }
    });
  }

  /**
   * Tras autenticarse con Okta, consulta la API para obtener los datos del
   * usuario en la base de datos. Si existen, permite el acceso al sistema;
   * si es null, regresa al login mostrando que el usuario no existe.
   */
  loginWithOkta(){
    this.spinner.show();

    this.usuarioService.getUserInfo().pipe(
      finalize(() => this.spinner.hide()) // El spinner siempre se oculta, pase lo que pase
    ).subscribe({
      next: (data: any) => {
        // El usuario no existe en la base de datos
        if (!data) {
          this.toastr.error('Tu usuario no existe en la base de datos.','Acceso denegado');
          this.logoutService.cerrarSesion();
          return;
        }

        this.tokenReaderService.setUserData(data);

        if (Number(data.idRol) === 5) {
          this.router.navigate(['/reportes']);
        } else {
          this.router.navigate(['/cargas']);
        }
      },
      error: (err) => {
        console.log('err :>> ', err);
        this.tokenReaderService.clear();
        if (err?.status === 404) {
          this.toastr.error('Tu usuario no existe en la base de datos.','Acceso denegado');
          this.logoutService.cerrarSesion();
        } else if (err?.status === 401) {
          this.toastr.error('Credenciales incorrectas', 'Acceso denegado');
        } else {
          const { Message, ExceptionMessage } = err?.error ?? {};
          this.toastr.error(
            ExceptionMessage ?? 'Comprueba tu conexión a la red',
            Message ?? 'Error desconocido'
          );
        }
      },
    });
  }
}
